import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { TubularsPanel } from "./TubularsPanel";

/**
 * Tubulars screen (§6) — the standalone route. Resolves the current well's
 * active event and renders the casing/liner strings + pipe tally + wellbore
 * schematic. Scoped by the well switcher via useCurrentWell, like every other
 * report screen.
 */
export function Tubulars() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();
  return (
    <div>
      <div className="page-head">
        <h1>{t("tub.title")}</h1>
        <p className="subtitle">
          {well ? `${well.commonName} · ${t("tub.subtitle")}` : t("well.notSelected")}
        </p>
      </div>
      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {activeEvent ? (
          <TubularsPanel eventId={activeEvent.id} unitProfileKey={activeEvent.unit_profile_key} />
        ) : null}
      </QueryState>
    </div>
  );
}
